import React, { createContext, useContext, useState } from "react";

export const SPECIALTIES = [
  { id: "cardiology",              label: "Кардиология" },
  { id: "functional_diagnostics",  label: "Функциональная диагностика" },
  { id: "arrhythmology",           label: "Аритмология" },
  { id: "neurology",               label: "Неврология" },
  { id: "surgery",                 label: "Хирургия" },
  { id: "therapy",                 label: "Терапия" },
  { id: "pediatrics",              label: "Педиатрия" },
  { id: "oncology",                label: "Онкология" },
  { id: "endocrinology",           label: "Эндокринология" },
  { id: "orthopedics",             label: "Травматология" },
  { id: "exercise_therapy",        label: "Лечебная физкультура и спортивная медицина" },
  { id: "manual_therapy",          label: "Мануальная терапия" },
];

const SpecialtyContext = createContext(null);
const STORAGE_KEY = "specialty";

// null означает «весь портал» — сводная лента без фильтра по специальности
// (см. Home.js). Явный выбор хранится в localStorage; для новых посетителей
// по умолчанию — весь портал, как было раньше единственным поведением.
function loadInitialSpecialty() {
  const savedId = localStorage.getItem(STORAGE_KEY);
  if (savedId === null) return null;               // ничего не сохранено — весь портал
  return SPECIALTIES.find(s => s.id === savedId) || null;
}

export function SpecialtyProvider({ children }) {
  const [specialty, setSpecialtyState] = useState(loadInitialSpecialty);

  const setSpecialty = s => {
    setSpecialtyState(s);
    if (s) localStorage.setItem(STORAGE_KEY, s.id);
    else localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <SpecialtyContext.Provider value={{ specialty, setSpecialty }}>
      {children}
    </SpecialtyContext.Provider>
  );
}

export function useSpecialty() {
  return useContext(SpecialtyContext);
}
